import React, { useContext } from "react";

import { Checkbox, FormControlLabel, FormGroup, FormLabel, Radio, RadioGroup, Typography, } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import styles from './style.module.css'
import { ChevronDown } from "react-feather"
import { observer } from "mobx-react";
import { Paper } from "../../../../../../../../common/components/libs";
import { OrderStatus } from "../../../../../../../../services/orders/models";
import { PaymentProviderType } from "../../../../../../../../services/general/models";
import TimePicker from "../TimePicker";
import { useTranslation } from "react-i18next";
import BookingStoreContext from "../../../../store/context";


const FilterForTable = () => {
    const bookingsStore = useContext(BookingStoreContext);
    const filter = bookingsStore.filter;
    const { t } = useTranslation(["general", "bookings"]);

    const handlePaymentTypeOnChange = (type: PaymentProviderType) => () => {
        const index = filter.paymentTypes.indexOf(type);
        let newValue;

        if (index < 0) {
            newValue = [
                ...filter.paymentTypes, type
            ]
        } else {
            newValue = filter.paymentTypes.filter(item => item !== type);
        }
        bookingsStore.setBookingsFilter({
            ...filter,
            paymentTypes: [
                ...newValue
            ]
        });
        bookingsStore.reloadOrders();
    };

    const currentStatuses = [OrderStatus.new, OrderStatus.canceled, OrderStatus.accepted]

    const handleStatusTypeOnChange = (type: OrderStatus) => () => {
        const index = filter.statuses.indexOf(type);
        let newValue = [];

        if (index < 0) {
            newValue = [
                ...filter.statuses, type
            ]
        } else {
            newValue = filter.statuses.filter(item => item !== type);
        }
        bookingsStore.setBookingsFilter({
            ...filter,
            statuses: [
                ...newValue
            ]
        });
        bookingsStore.reloadOrders();

    };

    const handlePaymentStatusOnChange = (paymentStatus: boolean) => () => {

        bookingsStore.setBookingsFilter({
            ...filter,
            isPaid: paymentStatus,
        });
        bookingsStore.reloadOrders();
    };


    return (
        <Paper style={{
            marginBottom: 10,
            display: "flex",
            flexDirection: "row",
            padding: 20,
        }}>
            <div className={styles.tooltipBlock}>
                <Typography className={styles.header}>
                    <span>{t("bookings:filter.timePeriod")}</span><ChevronDown size={14}/>
                </Typography>
                <Paper className={styles.tooltipBlockContent}>
                    <FormControl component="fieldset">
                        <TimePicker/>
                    </FormControl>
                </Paper>
            </div>
            <div className={styles.tooltipBlock}>
                <Typography className={styles.header}>
                    <span>{t("bookings:filter.orderStage")}</span><ChevronDown size={14}/>
                </Typography>
                <Paper className={styles.tooltipBlockContent}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">{t("bookings:filter.selectOrderStage")}</FormLabel>
                        <FormGroup>
                            <div style={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "space-between",
                                maxWidth: "400px"
                            }}>
                                {Object.values(currentStatuses).map(item => {
                                    return (
                                        <FormControlLabel
                                            key={item}
                                            control={
                                                <Checkbox
                                                    checked={filter.statuses.indexOf(item) >= 0}
                                                    onChange={handleStatusTypeOnChange(item)}
                                                    value={item}
                                                />
                                            }
                                            label={t(`bookings:orderStatus.${item}`)}
                                            style={{ width: "40%" }}
                                        />

                                    )
                                })}
                            </div>
                        </FormGroup>

                    </FormControl>
                </Paper>
            </div>
            <div className={styles.tooltipBlock}>
                <Typography className={styles.header}>
                    <span>{t("bookings:paymentType")}</span><ChevronDown size={14}/>
                </Typography>
                <Paper className={styles.tooltipBlockContent}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">{t("bookings:filter.selectPaymentType")}</FormLabel>
                        <FormGroup>
                            {Object.values(PaymentProviderType).map(item => {
                                return (
                                    <FormControlLabel
                                        key={item}
                                        control={
                                            <Checkbox
                                                checked={filter.paymentTypes.indexOf(item) >= 0}
                                                onChange={handlePaymentTypeOnChange(item)}
                                                value={item}
                                            />
                                        }
                                        label={t(`bookings:paymentProviderType.${item}`)}
                                    />
                                )
                            })}
                        </FormGroup>
                    </FormControl>
                </Paper>
            </div>
            <div className={styles.tooltipBlock}>
                <Typography className={styles.header}>
                    <span>{t("bookings:paymentState")}</span><ChevronDown size={14}/>
                </Typography>
                <Paper className={styles.tooltipBlockContent}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">{t("bookings:filter.selectType")}</FormLabel>
                        <RadioGroup>
                            <FormControlLabel
                                control={
                                    <Radio
                                        checked={filter.isPaid === false}
                                        onChange={handlePaymentStatusOnChange(false)}
                                        value={t("bookings:notPaid")}
                                    />
                                }
                                label={t("bookings:notPaid")}
                            />
                            <FormControlLabel
                                control={
                                    <Radio
                                        checked={filter.isPaid === true}
                                        onChange={handlePaymentStatusOnChange(true)}
                                        value={t("bookings:paid")}
                                    />
                                }
                                label={t("bookings:paid")}
                            />
                            <FormControlLabel
                                control={
                                    <Radio
                                        checked={filter.isPaid === null}
                                        onChange={handlePaymentStatusOnChange(null)}
                                        value={t("bookings:filter.all")}
                                    />
                                }
                                label={t("bookings:filter.all")}
                            />
                        </RadioGroup>
                    </FormControl>
                </Paper>
            </div>
        </Paper>
    )
};


export default observer(FilterForTable)


